export default __webpack_public_path__ + "imgs/charity.f15fc99644f13ad53879b4dfb5becf43.svg";